export default [
    {
        path: "tipo-producto",
        name: "tipoProductos",
        component: () => import(/* webpackChunkName: "gestionTipoProducto" */ "./tipoProducto.vue"),
    }
]